// extracted by mini-css-extract-plugin
export var badge = "_h2-2";
export var detailsPanel = "_h2-0";
export var resultRow = "_h2-1";